var cov_174vq0rp99 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/context.tsx",
      hash = "964cf66ebba262825137e3951d0f6e1d482339f4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "1": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "2": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "3": {
        start: {
          line: 12,
          column: 31
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 118
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 19,
          column: 13
        }
      },
      "6": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 108
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 31
          },
          end: {
            line: 12,
            column: 32
          }
        },
        loc: {
          start: {
            line: 12,
            column: 118
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 118
          },
          end: {
            line: 12,
            column: 119
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 19,
            column: 13
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 5
          },
          end: {
            line: 16,
            column: 6
          }
        },
        loc: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 17,
            column: 108
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 14
          },
          end: {
            line: 16,
            column: 16
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_174vq0rp99.s[0]++, createReactContext({}));

var _ref = (cov_174vq0rp99.s[1]++, context),
    Consumer = _ref.Consumer; // eslint-disable-next-line


export var Provider = (cov_174vq0rp99.s[2]++, context.Provider);
cov_174vq0rp99.s[3]++;
export var scrollConsumer = function scrollConsumer(Origin) {
  cov_174vq0rp99.f[0]++;
  cov_174vq0rp99.s[4]++;
  return function (props) {
    cov_174vq0rp99.f[1]++;
    cov_174vq0rp99.s[5]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15,
          columnNumber: 3
        }
      }, function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_174vq0rp99.b[0][0]++, {});
        cov_174vq0rp99.f[2]++;
        cov_174vq0rp99.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            scrollElement: value.element,
            scrollLeft: value.left,
            scrollTop: value.top,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 17,
              columnNumber: 7
            }
          }))
        );
      })
    );
  };
};